import { render, staticRenderFns } from "./QualityPPsManager.vue?vue&type=template&id=5a04e529&"
import script from "./QualityPPsManager.vue?vue&type=script&lang=ts&"
export * from "./QualityPPsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports